import Swiper from "swiper/dist/js/swiper";
import "jquery-scroll-lock";
import "magnific-popup";
import "@fancyapps/fancybox";

class App {
	constructor(options) {
		this.$win = $(window);
		this.$doc = $(document);
		this.$html = $(document.documentElement);
		this.$body = $(document.documentElement.lastElementChild);
		this.sliders = options.sliders;

		this.init();
	}

	init() {
		this.initSliders();
		this.initClickEvents();
		this.navDropdown();
		this.initScrollLock();
		this.jsHoverOnProducts();
		this.jsProducts();
		this.initTabs();
		this.initMagnificPopup();
		this.addresses();
		this.collapsingMenu();
		this.shipping();
		this.cart();
		this.triggerColor();
	}

	triggerColor() {
		const that = this;
		that.$win.on("load", function() {
			$(".form__body select").trigger("change");
		});
	}

	initSliders() {
		const that = this;

		this.sliders = this.sliders.map(slider => {
			const swiper = $(slider.selector).length ? new Swiper(slider.selector, slider.options) : null;

			return { ...slider, swiper };
		});

		that.$win.on("load resize", function() {
			if (that.$win.width() <= 768 && $(".slider-products").length) {
				that.sliders[1].swiper.destroy();

				const productSlider = new Swiper(".slider-products .swiper-container", {
					speed: 700,
					direction: "horizontal",
					autoHeight: true,
					pagination: {
						el: ".slider-products .swiper-pagination",
						type: "bullets",
						clickable: true
					},
					navigation: {
						nextEl: ".slider-products .slider__next",
						prevEl: ".slider-products .slider__prev"
					}
				});
			} else {
				const productSLider = new Swiper(".slider-product .swiper-container", {
					speed: 700,
					direction: "vertical",
					pagination: {
						el: ".slider-products .swiper-pagination",
						type: "bullets",
						clickable: true
					},
					navigation: {
						nextEl: ".slider-products .slider__next",
						prevEl: ".slider-products .slider__prev"
					}
				});
			}
		});

		if ($(".slider-single-product-thumbs-js-one").length) {
			that.sliders[4].swiper.slides.on("click click.update", function(event, test) {
				const sliderIndex = $(this).data("index");

				that.sliders[3].swiper.slideTo(sliderIndex);

				if (event.clientX == 0) {
					that.sliders[4].swiper.slideTo(sliderIndex);
				}
			});
		}

		if ($(".slider-single-product-thumbs-js-two").length) {
			const that = this;

			that.sliders[5].swiper.slides.on("click click.update", function() {
				const sliderIndex = $(this).data("index");

				that.sliders[3].swiper.slideTo(sliderIndex);
			});
		}
	}

	initClickEvents() {
		const $sideNav = $(".side-nav");
		const $headerWrapper = $(".header .header__wrapper");

		//Open Navigation
		$(".btn-menu").on("click", function(event) {
			event.preventDefault();

			$sideNav.addClass("open");
			$headerWrapper.addClass("hide");
		});

		//Close Navigation
		$(".side-nav__close").on("click", function(event) {
			event.preventDefault();

			$sideNav.removeClass("open");
			$headerWrapper.removeClass("hide");
		});

		//Open / Close Shop Dropdown
		$(".link-shop").on("click", function(event) {
			event.preventDefault();

			$(".nav-secondary").toggleClass("open");
			$(this).toggleClass("active");
		});

		//Change images on Product Page
		$(".list-images span").on("click click.update", function() {
			const $this = $(this);
			const src = $this.data("image");
			const srcFull = $this.data("full");

			$this.parents(".product-single .product__image").find("a").attr("href", srcFull);
			$this.parents(".product-single .product__image").find(".product__image-holder img").attr("src", src);
		});

		//Close when click outside
		this.$doc.on("click touchstart", function(event) {
			if (!$(event.target) === ".btn-menu, .side-nav" || !$(event.target).closest(".btn-menu, .side-nav").length) {
				$sideNav.removeClass("open");
				$headerWrapper.removeClass("hide");
			}
		});
	}

	navDropdown() {
		$(".nav li").each(function() {
			const $this = $(this);
			const $link = $this.find(" > a");

			if ($link.next().length) {
				$this.addClass("has-dropdown");
			}
		});

		$(".nav .has-dropdown > a").on("click", function(event) {
			event.preventDefault();

			const $link = $(this);
			const $dropdown = $link.next("ul");

			$link.parent().toggleClass("active");
			$dropdown.slideToggle();
		});
	}

	initScrollLock() {
		$(".side-nav .side-nav__body").scrollLock("enable");
	}

	jsHoverOnProducts() {
		//Hover on colors
		this.$doc.on("mouseenter touchstart", ".list-colors span", function() {
			const $this = $(this);
			const src = $this.data("image");
			const price = $this.data("price");
			const url = $this.data("url");
			const option = $this.data("option");
			const optionValue = $this.data("option-value");

			$this.parents(".product").find(".product__image .img").css(`background-image`, `url(${src})`);

			$this.parents(".product").find(".product__price").html(price);

			$this.parents(".list-colors").children("li").removeClass("current");
			$this.parents(".list-colors li").addClass("current");

			$this.closest(".product").find(".btn, .product__inner a").attr("href", url);

			$this.closest(".product").find(`select[name="${option}"]`).val(optionValue);

			$this.closest(".product").find(`.select-variants option[data-${option}="${optionValue}"]`).eq(0).prop("selected", true).trigger("change.image");
		});
	}

	jsProducts() {
		this.$doc.on("change.image", ".popup .select-variants", event => {
			const $option = $(event.target);
			const $image = $option.closest(".popup").find(".popup__image");
			const image = $option.data("image");

			$image.css({
				"background-image": `url(${image})`
			});
		});

		this.$doc.on("change", ".select-filters select", event => {
			window.location = event.target.value;
		});

		$(".product-single .form-product .select select").on("change", function(event) {
			const $select = $(this);
			const $form = $select.closest("form");
			const selector = $form
				.serializeArray()
				.filter(item => item.name.indexOf("option") == 0)
				.map(item => `[data-${item.name}="${item.value}"]`)
				.join("");
			if ($form.find(`[name="id"] ${selector}`).length) {
				$form.find('.btn[type="submit"]').prop("disabled", false).val("Add to Cart");
				$form.find(`[name="id"] ${selector}`).prop("selected", true).trigger("change.update");
			} else {
				$form.find('.btn[type="submit"]').prop("disabled", true).val("Unavailable");
			}
		});

		$(".template-multi-options .form-product .select select")
			.on("change", function() {
				const $this = $(this);
				const $select = $(".select-variants");
				const $selectOption = $select.find(`option[value="${$select.val()}"]`);
				const image = $selectOption.data("image");
				const $mainCol = $(".form__cols--main");

				let $imgWrapper = `<div class="spec-wrapper"><img src="${image}" /></div>`;

				$mainCol.find(".spec-wrapper").remove();

				if ($mainCol.children().length > 1) {
					$mainCol.children().last().prev().after($imgWrapper);
				} else {
					$mainCol.children().after($imgWrapper);
				}
			})
			.trigger("change");

		$(".slider-control--color").on("change", function() {
			$(".slider-single-product-thumbs").find(`.slider__slide[data-color="${$(this).val()}"]`).trigger("click");
		});

		const $productContainer = $(".product-single");
		const $productPrice = $productContainer.find(".product__price");
		const $productWeight = $productContainer.find(".product__info span");
		const $sliderThumbs = $productContainer.find(".slider-single-product-thumbs .slider__slide, .product__image .list-images span");

		$productContainer.on("change.update", 'select[name="id"]', event => {
			const $option = $(event.target);
			const id = event.target.value;
			const price = $option.data("price");
			const weight = $option.data("weight");
			$productWeight.html(weight);
			$productPrice.html(price);
			$sliderThumbs.filter(`[data-variants*="${id}"]`).trigger("click.update");
		});
	}

	initTabs() {
		$(".tabs__nav a").on("click", function(event) {
			event.preventDefault();

			const target = $(this).attr("href");

			$(this).parent().addClass("active").siblings().removeClass("active");

			$(target).addClass("active").siblings().removeClass("active");
		});
	}

	initMagnificPopup() {
		$(".section-addons .product .product__inner a, .section-addons .btn-popup").not("[data-popup]").magnificPopup({
			type: "inline",
			mainClass: "mfp-fade",
			removalDelay: 160
		});

		$(".image-popup").fancybox({
			animationEffect: "zoom-in-out",
			buttons: ["zoom", "thumbs", "close"],
			backFocus: false,
			slideShow: {
					speed: 5000
				}
		});

		$(".popup-trigger").on("click", function(e) {
			e.preventDefault();
			const $this = $(this);
			const thisSrc = $this.attr("href");
			let items = [];
			items.push({ src: thisSrc });
			$(".list-images li").each(function() {
				const $self = $(this);
				const srcFull = $self.find("span").data("full");
				if (srcFull !== thisSrc) {
					items.push({ src: srcFull });
				}
			});
			$.fancybox.open(items, {
				animationEffect: "zoom-in-out",
				buttons: ["zoom", "thumbs", "close"],
				backFocus: false,
				slideShow: {
					speed: 5000
				}
			});
			// $.magnificPopup.open({
			// 	items: items,
			// 	type: "image",
			// 	gallery: {
			// 		enabled: true
			// 	}
			// });
		});

		$(".section-addons [data-popup]").on("click", function(event) {
			const $button = $(this);
			const $container = $($button.data("popup"));

			if ($container.length) {
				event.preventDefault();

				$.magnificPopup.open({
					items: [
						{
							src: $button.data("popup"),
							type: "inline"
						}
					],
					mainClass: "mfp-fade",
					removalDelay: 160
				});
			}
		});

		$(".section-videos .article__image a").on("click", function(event) {
			const $button = $(this);
			const popupHTML = $button.closest(".article").find(".popup-template").html();

			event.preventDefault();

			$.magnificPopup.open({
				items: [
					{
						src: popupHTML,
						type: "inline"
					}
				],
				mainClass: "mfp-fade",
				removalDelay: 160
			});
		});
	}

	addresses() {
		const selects = [...document.querySelectorAll('[id*="field-country-"]')];

		if (!window.Shopify) {
			return;
		}

		if (selects.length) {
			selects.map(select => {
				const options = JSON.parse(select.getAttribute("data-object") || "{}");

				new Shopify.CountryProvinceSelector(options.country, options.province, options.options);

				return select;
			});
		}
	}

	collapsingMenu() {
		const checkItems = () => {
			const $filterLinks = $(".list-filters a");
			let showSelect = false;

			$filterLinks.each(function() {
				const $link = $(this);
				const $span = $link.find("span");

				if (showSelect == false && $link.height() >= $span.height()) {
					showSelect = true;
				}
			});

			return showSelect;
		};

		const $filterContainer = $(".list-filters");
		const $filterSelect = $(".select-filters--alt");

		this.$win.on(
			"load resize",
			this.debounce(event => {
				if (this.$win.width() > 1023 && checkItems()) {
					$filterContainer.addClass("list-filters--hidden");
					$filterSelect.removeClass("hidden-lg hidden-md visible-sm visible-xs");
				} else {
					$filterContainer.removeClass("list-filters--hidden");
					$filterSelect.addClass("hidden-lg hidden-md visible-sm visible-xs");
				}
			}, 300)
		);
	}

	shipping() {
		if (this.$body.hasClass("template-cart")) {
			Shopify.Cart.ShippingCalculator.show({
				submitButton: Shopify.theme.locale.shipping.shippingCalcSubmitButton,
				submitButtonDisabled: Shopify.theme.locale.shipping.shippingCalcSubmitButtonDisabled,
				customerIsLoggedIn: Shopify.theme.locale.shipping.shippingCalcCustomerIsLoggedIn,
				moneyFormat: Shopify.theme.locale.shipping.shippingCalcMoneyFormat
			});
		}
	}

	cart() {
		const $cart = $(".form-cart");
		const $cartSubmit = $cart.find("input:submit");
		$cart.on(
			"change input",
			" .cart-products .field",
			this.debounce(event => {
				$cartSubmit.prop("disabled", true);

				let updates = { updates: {} };

				$cart.find(".cart-products .field").each(function(index) {
					let $item = $(this);

					updates.updates[$item.data("id")] = $item.val();
				});

				$cart.find(".cart-products .cart-product").css("opacity", 0.7);

				$.ajax({
					url: "/cart/update.js",
					type: "POST",
					dataType: "html",
					data: updates
				})
					.done(function(data) {
						$cartSubmit.prop("disabled", false);

						$.ajax({
							url: "/cart"
						}).done(function(html) {
							const $html = $(html);

							$cart.find(".cart-products").html($html.find(".cart-products").html());

							$cart.find(".form__aside .form__total").html($html.find(".form__aside .form__total").html());
						});
					})
					.fail(function(error) {
						alert(JSON.parse(error.responseText).description);
					});
			}, 500)
		);
	}

	debounce(func, wait, immediate) {
		var timeout;
		return function() {
			var context = this,
				args = arguments;

			var later = function() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};

			var callNow = immediate && !timeout;

			clearTimeout(timeout);

			timeout = setTimeout(later, wait);

			if (callNow) func.apply(context, args);
		};
	}
}

const app = new App({
	sliders: [
		{
			selector: ".slider-intro .swiper-container",
			options: {
				speed: 700,
				loop: true,
				autoplay: true,
				disableOnInteraction: false,
				pagination: {
					el: ".slider-intro .swiper-pagination",
					type: "bullets",
					clickable: true
				}
			}
		},
		{
			selector: ".slider-products .swiper-container",
			options: {
				speed: 700,
				direction: "vertical",
				pagination: {
					el: ".slider-products .swiper-pagination",
					type: "bullets",
					clickable: true
				},
				navigation: {
					nextEl: ".slider-products .slider__next",
					prevEl: ".slider-products .slider__prev"
				},
				breakpoints: {
					1023: {
						direction: "horizontal",
						effect: "slide",
						autoHeight: true
					}
				}
			}
		},
		{
			selector: ".slider-related .swiper-container",
			options: {
				speed: 700,
				loop: true,
				autoplay: true,
				disableOnInteraction: false,
				slidesPerView: 4,
				navigation: {
					nextEl: ".slider-related .slider__next",
					prevEl: ".slider-related .slider__prev"
				},
				breakpoints: {
					1023: {
						slidesPerView: 3
					},
					767: {
						slidesPerView: 1
					}
				}
			}
		},
		{
			selector: ".slider-single-product .swiper-container",
			options: {
				speed: 700,
				spaceBetween: 10,
				simulateTouch: false
			}
		},
		{
			selector: ".slider-single-product-thumbs-js-one .swiper-container",
			options: {
				speed: 700,
				slidesPerView: 4,
				spaceBetween: 10,
				simulateTouch: false,
				navigation: {
					nextEl: ".slider-single-product-thumbs-js-one .slider__next",
					prevEl: ".slider-single-product-thumbs-js-one .slider__prev"
				},
				breakpoints: {
					767: {
						slidesPerView: 2
					}
				}
			}
		},
		{
			selector: ".slider-single-product-thumbs-js-two .swiper-container",
			options: {
				speed: 700,
				slidesPerView: 6,
				spaceBetween: 10,
				simulateTouch: false,
				navigation: {
					nextEl: ".slider-single-product-thumbs-js-two .slider__next",
					prevEl: ".slider-single-product-thumbs-js-two .slider__prev"
				},
				breakpoints: {
					767: {
						slidesPerView: 2
					}
				}
			}
		},
		{
			selector: ".slider-testimonials .swiper-container",
			options: {
				speed: 700,
				autoHeight: true,
				loop: true,
				autoplay: true,
				navigation: {
					nextEl: ".slider-testimonials .slider__next",
					prevEl: ".slider-testimonials .slider__prev"
				},
				pagination: {
					el: ".slider-testimonials .swiper-pagination",
					type: "bullets",
					clickable: true
				}
			}
		}
	]
});



// WEBPACK FOOTER //
// ./../src/assets/js/main.js